import * as Article from '@elevio/kb-kit/lib/components/article';
import * as Search from '@elevio/kb-kit/lib/components/search';
import { useTranslation } from '@elevio/kb-kit/lib/hooks';
import ArticleActions from '../components/ArticleActions';
import ArticleList from '../components/ArticleList';
import ArticleMeta from '../components/ArticleMeta';
import Footer from '../components/Footer';
import Header from '../components/Header';
import PageLayout from '../components/layouts/Page';
import WithAsideLayout, { Aside, Main, MainBody, MainHeader, } from '../components/layouts/WithAside';
function Page() {
    const { t: translate } = useTranslation();
    return (<PageLayout header={<Header />} footer={<Footer />}>
      <WithAsideLayout>
        <Aside>
          <Search.Input className="sidebar-search" placeholder={translate('search.shortplaceholder', 'Search...')} data-testid="article-search-input"/>
          <ArticleList isRelated isAside/>
        </Aside>

        <Main>
          <MainHeader>
            <ArticleActions />
            <h1 className="main-title faq-article-title" data-testid="article-title">
              <Article.Title />
            </h1>
            <ArticleMeta />
          </MainHeader>

          <MainBody>
            <Article.Body />
          </MainBody>
        </Main>
      </WithAsideLayout>
    </PageLayout>);
}
export default Page;
